<template>
    <div class="container">
        <b-modal :model-value="modCreaRedFila" :no-close-on-backdrop="true" hide-header hide-footer centered class="custom-dialog">
            <div class="dialog-header">
                <span class="header-title">{{ labels.title }}</span> 
            </div>
            <div class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.niif }}</label> 
                                <input type="number" v-model="niif" placeholder="labels.niif" /> 
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.descripcion }}</label> 
                                <input type="text" v-model="descripcion" placeholder="labels.descripcion" /> 
                        </div>
                    </div>
                    <!-- Niveles -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.primerNivel }}</label> 
                                <input type="number" v-model="primerNivel" placeholder="labels.primerNivel" /> 
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.segundoNivel }}</label> 
                                <input type="number" v-model="segundoNivel" placeholder="labels.segundoNivel" /> 
                        </div>
                    </div>
                    <!-- Configuración -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.actual }}</label> 
                                <select v-model="actual" class="modern-select">
                                    <option value="">{{ labels.select }}</option> 
                                    <option value="1">{{ labels.yes }}</option> 
                                    <option value="0">{{ labels.not }}</option> 
                                </select>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.operacion }}</label> 
                                <select v-model="operacion" class="modern-select">
                                    <option value="">{{ labels.select }}</option> 
                                    <option value="+">{{ labels.sumar }}</option> 
                                    <option value="-">{{ labels.restar }}</option> 
                                </select>
                        </div>
                    </div>
                    <!-- Pestañas de selección -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.niifSelect }}</label> 
                        <div class="tabs-container">
                            <!-- Pestañas -->
                            <div class="tabs-header">
                                <button class="tab-button" :class="{ active: activeTab === 'niif' }"
                                    @click="changeTab('niif')">
                                    {{ labels.tabNiif }} 
                                </button>
                                <button class="tab-button" :class="{ active: activeTab === 'redefiniciones' }"
                                    @click="changeTab('redefiniciones')">
                                    {{ labels.tabRedefiniciones }} 
                                </button>
                            </div>
                            <!-- Contenido de pestañas -->
                            <div class="tab-content">
                                <!-- Pestaña NIIF -->
                                <div v-if="activeTab === 'niif'" class="niif-selection-container">
                                    <div class="search-bar">
                                          <input v-model="searchNiif" placeholder="labels.searchPlaceholder" /> 
                                        <div class="selection-info">
                                          {{ labels.selected }}: {{ selectedNiifs?.length }} / {{ filteredNiif?.length 
                                            }}
                                        </div>
                                    </div>
                                    <div class="niif-table-container">
                                        <table class="niif-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAll"
                                                            @change="toggleSelectAll" />
                                                    </th>
                                                    <th class="niif-column">NIIF</th>
                                                    <th class="desc-column">Descripción</th>
                                                    <th class="level-column">Nivel 1</th>
                                          <th class="level-desc-column">Desc. Nivel 1</th> 
                                                    <th class="level-column">Nivel 2</th>
                                          <th class="level-desc-column">Desc. Nivel 2</th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                          <tr v-for="niif in filteredNiif" :key="niif.id"> 
                                                    <td class="checkbox-column">
                                          <md-checkbox v-model="niif._selected" 
                                                            @change="onNiifCheckboxChange(niif)"
                                                            class="custom-checkbox"></md-checkbox>
                                                    </td>
                                          <td class="niif-column">{{ niif?.niif }}</td>                                           <td class="desc-column" :title="niif.nameNiif || niif.descripcion"> 
                                          {{ niif?.nameNiif || niif?.descripcion }}                                                     </td>
                                          <td class="level-column">{{ niif?.primer_nivel }}</td>                                                     <td class="level-desc-column"
                                          :title=" getFirstLevelDescription(niif.primer_nivel) "> 
                                          {{ getFirstLevelDescription(niif?.primer_nivel) }}                                                     </td>
                                          <td class="level-column">{{ niif?.segundo_nivel }}</td>                                                     <td class="level-desc-column"
                                          :title=" getSecondLevelDescription(niif.niif) "> 
                                          {{ getSecondLevelDescription(niif?.niif) }}                                                     </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredNiif?.length === 0" class="no-results">{{ labels.noResults }} 
                                        </div>
                                    </div>
                                </div>
                                <!-- Pestaña Redefiniciones -->
                                <div v-if="activeTab === 'redefiniciones'" class="redefiniciones-selection-container">
                                    <div class="search-bar">
                                          <input placeholder="labels.searchRedefPlaceholder" 
                                                v-model="searchRedefinicion" @input="filterRedefiniciones" />
                                        <div class="selection-info">
                                          {{ labels.selected }}: {{ selectedRedefiniciones?.length }} / {{ 
                                          filteredRedefiniciones.length }} 
                                        </div>
                                    </div>
                                    <div class="redefiniciones-table-container">
                                        <table class="redefiniciones-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAllRedef"
                                                            @change="toggleSelectAllRedef" />
                                                    </th>
                                                    <th class="niif-column sortable" @click="sortByRedef('niif')">
                                          {{ labels.niif }} 
                                                        <span class="sort-indicator" v-if="sortColumnRedef === 'niif'">
                                          {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="desc-column sortable"
                                                        @click="sortByRedef('descripcion')">
                                          {{ labels.description }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumnRedef === 'descripcion'">
                                          {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-column">
                                          {{ labels.levelFirst }} 
                                                    </th>
                                                    <th class="level-column">
                                          {{ labels.levelSecond }} 
                                                    </th>
                                                    <th class="formulation-column">
                                          {{ labels.formulacion }} 
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                          <tr v-for="redef in sortedRedefiniciones" :key="redef.id" 
                                                    class="clickable-row">
                                                    <td class="checkbox-column">
                                          <md-checkbox v-model="redef._selected" 
                                                            @change="onRedefinicionCheckboxChange(redef)"
                                                            class="custom-checkbox" />
                                                    </td>
                                          <td class="niif-column">{{ redef?.niif }}</td>                                           <td class="desc-column" :title="redef.descripcion"> 
                                          {{ redef?.descripcion }}                                                     </td>
                                          <td class="level-column">{{ redef?.primer_nivel }}</td>                                           <td class="level-column">{{ redef?.segundo_nivel }}</td>                                           <td class="formulation-column" :title="redef.formulacion"> 
                                          {{ truncateFormulation(redef?.formulacion) }}                                                     </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredRedefiniciones?.length === 0" class="no-results">                                           {{ labels.noRedefResults }} 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-actions">
                <b-button class="md-raised cancel-btn" @click="closeDialog">
                    {{ labels.close }} 
                </b-button>
                <b-button class="md-raised md-primary save-btn" @click="confirmSave">
                    {{ labels.save }} 
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PrimerNivel from '../../../services/PrimerNivel' 
import SegundoNivel from '../../../services/SegundoNivel' 
import PlanConsolidacion from '../../../services/PlanConsolidacion'; 
import RedefinicionFila from '../../../services/RedefinicionFila'; 
export default {
    name: 'CreaRedefinicionFila',
    props:['modCreaRedFila','vigenciaSelected','codReporte'],
    data: () => ({
        niif: "",
        descripcion: "",
        primerNivel: "",
        listFirstLevel: [],
        segundoNivel: "",
        listSecondLev: [],
        actual: "",
        operacion: "",
        niifSelect: [],
        listNiif: [],
        searchNiif: "",
        selectedNiifs: [],
        selectAll: false,
        hasUnsavedChanges: false,
        activeTab: 'niif',
        listRedefiniciones: [],
        filteredRedefiniciones: [],
        searchRedefinicion: '',
        selectedRedefiniciones: [],
        selectAllRedef: false,
        sortColumnRedef: 'niif',
        sortDirectionRedef: 'asc'
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title: "Crear fila",
                    save: "Guardar",
                    close: "Cerrar",
                    niif: "Niif",
                    descripcion: "Descripción",
                    primerNivel: "Primer nivel",
                    segundoNivel: "Segundo nivel",
                    actual: "Actual",
                    yes: "SI",
                    not: "NO",
                    operacion: "Operación",
                    sumar: "Sumar",
                    restar: "Restar",
                    niifSelect: "Seleccionar NIIF",
                    select: "Seleccione...", 
                    searchPlaceholder: "Buscar NIIF...", 
                    selected: "Seleccionados",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefiniciones",
                    searchRedefPlaceholder: "Buscar redefiniciones...", 
                    noRedefResults: "No se encontraron redefiniciones",
                    showing: "Mostrando",
                    formulacion: "Formulación"
                }
            }else{
                return {
                    title: "Create row",
                    save: "Save",
                    close: "Close",
                    niif: "Niif",
                    descripcion: "Description",
                    primerNivel: "First level",
                    segundoNivel: "Second level",
                    actual: "Current",
                    yes: "YES",
                    not: "NOT",
                    operacion: "Operation",
                    sumar: "Add",
                    restar: "Subtract",
                    niifSelect: "Select NIIF",
                    select: "Select...", 
                    searchPlaceholder: "Search NIIF...", 
                    selected: "Selected",
                    noResults: "No results found",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefinitions",
                    searchRedefPlaceholder: "Search redefinitions...", 
                    noRedefResults: "No redefinitions found",
                    showing: "Showing",
                    formulacion: "Formulation"
                }
            }
        },
        filteredNiif() {
            const term = this.searchNiif.toLowerCase() || "";
            return this.listNiif.filter(n =>
                n.niif.toString().includes(term) || 
                (n.nameNiif && n.nameNiif.toLowerCase().includes(term)) || 
                (n.descripcion && n.descripcion.toLowerCase().includes(term)) 
            );
        },
        sortedRedefiniciones() {
            if (!this.filteredRedefiniciones.length) return [];
            return [...this.filteredRedefiniciones].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumnRedef) {
                    case 'niif':
                        aValue = parseInt(a.niif); 
                        bValue = parseInt(b.niif); 
                        break;
                    case 'descripcion':
                        aValue = (a.descripcion || '').toLowerCase(); 
                        bValue = (b.descripcion || '').toLowerCase(); 
                        break;
                    default:
                        aValue = a[this.sortColumnRedef];
                        bValue = b[this.sortColumnRedef];
                }
                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue); 
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }
                return this.sortDirectionRedef === 'desc' ? -result : result;
            });
        }
    },
    watch: {
        niif() { this.hasUnsavedChanges = true; },
        descripcion() { this.hasUnsavedChanges = true; },
        primerNivel() { 
            this.hasUnsavedChanges = true;
            if(this.primerNivel) {
                SegundoNivel.getAllLevelSecondByLevelFirst(this.primerNivel)
                .then((res) => { 
                    this.listSecondLev = res.data.secondLevByFirstLev
                })
                .catch((err) => console.log(err)) 
            }
        },
        segundoNivel() { this.hasUnsavedChanges = true; },
        actual() { this.hasUnsavedChanges = true; },
        operacion() { this.hasUnsavedChanges = true; },
        modCreaRedFila(val) {
            if(val){
                PlanConsolidacion.getPlanConsPorCompVige(this.vigenciaSelected, this.codReporte)
                    .then((res) => { 
                        this.listNiif = res.data.planConsNiif || [];
                        this.listNiif.forEach(n => n._selected = false);
                        this.selectedNiifs = [];
                        PrimerNivel.getFirstLevelByReporte(this.codReporte)
                            .then((result) => { 
                                this.listFirstLevel = result.data.firstLevByReport || [];
                            });
                        this.listSecondLev = [];
                        const firstLevels = this.listFirstLevel.map(f => f.primer_nivel);
                        const promises = firstLevels.map(firstLevel => 
                            SegundoNivel.getAllLevelSecondByLevelFirstByReport(firstLevel, this.codReporte)
                                .then(res => { 
                                    if (res.data.secondLevByFirstLev) { 
                                        this.listSecondLev = [...this.listSecondLev, ...res.data.secondLevByFirstLev];
                                    }
                                })
                                .catch(err => { 
                                    console.log(`Error al cargar segundo nivel del nivel ${firstLevel}:`, err); 
                                })
                        );
                        Promise.all(promises).then(() => { 
                            console.log("Segundo nivel cargado:", this.listSecondLev);
                        });
                    })
                    .catch((err) => console.log(err)) 
            } else {
                this.clearFields();
            }
        }
    },
    methods:{
        clearFields() {
            this.niif = "";
            this.descripcion = "";
            this.primerNivel = "";
            this.segundoNivel = "";
            this.actual = "";
            this.operacion = "";
            this.niifSelect = [];
            this.listNiif = [];
            this.selectedNiifs = [];
            this.hasUnsavedChanges = false;
            this.selectAll = false;
            this.searchNiif = "";
        },
        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";
                    
                if (window.confirm(message)) { 
                    this.closeModal();
                }
            } else {
                this.closeModal();
            }
        },
        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea crear esta fila?"
                : "Are you sure you want to create this row?";
                
            if (window.confirm(message)) { 
                this.guardaRedFila();
            }
        },
        closeModal(){
            this.$emit('cierraModal',false)
            this.clearFields();
        },
        onNiifCheckboxChange(niif) {
            if (niif._selected) { 
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif);
            }
            this.updateSelectAllState();
        },
        updateSelectAllState() {
            if (this.filteredNiif.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiif.every(n => n._selected);
        },
        toggleSelectAll() {
            if (!this.selectAll) {
                this.filteredNiif.forEach(n => {
                    if (!n._selected) { 
                        n._selected = true; 
                        if (!this.selectedNiifs.some(s => s.niif === n.niif)) this.selectedNiifs.push(n);
                    }
                });
                this.selectAll = true;
            } else {
                this.filteredNiif.forEach(n => n._selected = false);
                this.selectedNiifs = this.selectedNiifs.filter(s => !this.filteredNiif.some(f => f.niif === s.niif));
                this.selectAll = false;
            }
        },
        getFirstLevelDescription(levelCode) {
            if (!levelCode) return '-';
            const level = this.listFirstLevel.find(item => item.primer_nivel == levelCode);
            return level ? level?.descripcion : '-'
        },
        getSecondLevelDescription(niif) {
            if (!niif) return '-';
            const level = this.listNiif.find(r_niif => r_niif.niif == niif );
            return level ? level?.nameSegundoNivel : '-'
        },
        guardaRedFila(){
            // enviar códigos de NIIF seleccionados
            const niifCodes = this.selectedNiifs.map(n => n.niif);
            let formData = {
                'codReporte': this.codReporte,
                'niif': this.niif,
                'descripcion': this.descripcion,
                'primerNivel': this.primerNivel,
                'segundoNivel': this.segundoNivel,
                'actual': this.actual,
                'operacion': this.operacion,
                'niifSelect': niifCodes,
                'idUser': this.$store.state.userId,
            }
            RedefinicionFila.createRedefinicionFila(formData) 
            .then((res) => { 
                this.$toast.success(res.data.message)
                this.closeModal();
                this.$emit('reload');
            })
            .catch((err) => { 
                console.log(err) 
                if(err.response && err.response.status == 412){ 
                    this.$toast.error(err.response.data.message)
                }
            }) 
        },
        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'redefiniciones' && this.listRedefiniciones.length === 0) {
                this.loadRedefiniciones();
            }
            if (tab === 'redefiniciones' && this.selectedNiifs.length === 0) {
                this.clearRedefinicionesSelection();
            }
        },
        loadRedefiniciones() {
            RedefinicionFila.getAllRedefinicionFilas(this.codReporte)
                .then(res => { 
                    this.listRedefiniciones = res.data.redefinicionFila || [];
                    this.listRedefiniciones.forEach(redef => redef._selected = false);
                    this.filteredRedefiniciones = [...this.listRedefiniciones];
                    this.selectedRedefiniciones = [];
                })
                .catch(err => { 
                    console.log('Error cargando redefiniciones:', err); 
                    this.listRedefiniciones = [];
                    this.filteredRedefiniciones = [];
                    this.selectedRedefiniciones = [];
                });
        },
        filterRedefiniciones() {
            if (!this.searchRedefinicion) {
                this.filteredRedefiniciones = [...this.listRedefiniciones];
            } else {
                const term = this.searchRedefinicion.toLowerCase();
                this.filteredRedefiniciones = this.listRedefiniciones.filter(item =>
                    item.niif.toString().includes(term) || 
                    (item.descripcion && item.descripcion.toLowerCase().includes(term)) 
                );
            }
            this.updateSelectAllRedefState();
        },
        sortByRedef(column) {
            if (this.sortColumnRedef === column) {
                this.sortDirectionRedef = this.sortDirectionRedef === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumnRedef = column;
                this.sortDirectionRedef = 'asc';
            }
        },
        onRedefinicionCheckboxChange(redef) {
            if (redef._selected) { 
                if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                    this.selectedRedefiniciones.push(redef);
                }
            } else {
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(r => r.id !== redef.id);
            }
            this.updateSelectAllRedefState();
            this.applyRedefinicionesSelection();
        },
        applyRedefinicionesSelection() {
            if (this.selectedRedefiniciones.length === 0) return;
            const allNiifCodes = new Set();
            this.selectedRedefiniciones.forEach(redef => {
                const niifCodes = this.extractNiifCodesFromFormulation(redef.formulacion);
                niifCodes.forEach(code => allNiifCodes.add(code)); 
            });
            const uniqueNiifCodes = Array.from(allNiifCodes); 
            this.listNiif.forEach(niif => {
                niif._selected = uniqueNiifCodes.includes(parseInt(niif.niif)); 
            });
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
            this.hasUnsavedChanges = true;
        },
        toggleSelectAllRedef() {
            if (!this.selectAllRedef) {
                this.filteredRedefiniciones.forEach(redef => {
                    if (!redef._selected) { 
                        redef._selected = true; 
                        if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                            this.selectedRedefiniciones.push(redef);
                        }
                    }
                });
                this.selectAllRedef = true;
            } else {
                this.filteredRedefiniciones.forEach(redef => redef._selected = false);
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(
                    s => !this.filteredRedefiniciones.some(f => f.id === s.id)
                );
                this.selectAllRedef = false;
            }
            this.applyRedefinicionesSelection();
        },
        updateSelectAllRedefState() {
            if (this.filteredRedefiniciones.length === 0) {
                this.selectAllRedef = false;
                return;
            }
            this.selectAllRedef = this.filteredRedefiniciones.every(redef => redef._selected);
        },
        clearRedefinicionesSelection() {
            this.selectedRedefiniciones = [];
            this.listRedefiniciones.forEach(redef => redef._selected = false);
            this.selectAllRedef = false;
        },
        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i); 
            if (niifMatch) {
                return niifMatch[1].split(',')?.map(num => parseInt(num.trim()))?.filter(num => !isNaN(num));             }
            return formulation?.replace(/[+-]/g, ',').split(',')?.map(n => parseInt(n.trim()))?.filter(n => !isNaN(n));         },
        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) { 
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i); 
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) { 
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i); 
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(','); 
                            if (numbers.length > 8) { 
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5), 
                                    '...', 
                                    ...numbers.slice(-3) 
                                ].join(','); 
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                return formulation?.substring(0, 50) + '..? ';             }
            return formulation;
        }
    },
    mounted(){
        if(this.codReporte) {
            PrimerNivel.getFirstLevelByReporte(this.codReporte)
            .then((result) => { 
                this.listFirstLevel = result.data.firstLevByReport || [];
            })
            .catch((err) => { 
                console.log(err) 
            })
        }
    }
}
</script>
